import CryptoJS from 'crypto-js'

const secretKey = 'amaryllo-key-GSN';

export function encryptData(data: object): string {
  const str = JSON.stringify(data);
  return CryptoJS.AES.encrypt(str, secretKey).toString();
}

export function decryptData(ciphertext: string): object {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedStr);
}